import { render } from "./DataHistory.vue?vue&type=template&id=0e4a2bb2&scoped=true"
import script from "./DataHistory.vue?vue&type=script&lang=js"
export * from "./DataHistory.vue?vue&type=script&lang=js"

import "./DataHistory.vue?vue&type=style&index=0&id=0e4a2bb2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4a2bb2"],['__file',"src/components/h5/data/DataHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e4a2bb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e4a2bb2', __exports__)) {
    api.reload('0e4a2bb2', __exports__)
  }
  
  module.hot.accept("./DataHistory.vue?vue&type=template&id=0e4a2bb2&scoped=true", () => {
    api.rerender('0e4a2bb2', render)
  })

}


export default __exports__